import React from 'react'
import Status from '../../../../UI/status/Status'
import { statusDeliverText } from '../../../../../helpers/status/StatusSupplyOrderHelper'

const SupplyBillDeliveryShort = ({ deliveries }) => {
  return (
    <div>
        {
            deliveries && deliveries.length > 0 ?
                deliveries.map(delivery => {
                    return (
                        <div
                            key={delivery.id}
                            className='deliveryShortOne'
                        >
                            <p>
                                {
                                    delivery.deliveryType ? delivery.deliveryType.name : ''
                                }
                            </p>
                            <Status
                                status={delivery.status}
                                text={statusDeliverText[delivery.status]}
                            />
                        </div>
                    )
                })
            : ''
        }
    </div>
  )
}

export default SupplyBillDeliveryShort